import React, { useState } from 'react';
import { Center, Text, VStack, IconButton } from 'native-base';
import { theme } from '@breakroom-nx/assets';
import { ActivityIndicator } from 'react-native';
import { RefreshIcon } from 'react-native-heroicons/solid';

export interface ErrorAndRefetchProps {
  onRefetch: () => Promise<void> | void; // Support async or sync functions
  error: string;
}

export function ErrorAndRefetch({ onRefetch, error }: ErrorAndRefetchProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleRefetch = async () => {
    setIsLoading(true);
    try {
      await onRefetch(); // Wait for the refetch function to complete
    } finally {
      // Add a short delay to ensure the animation is visible
      setTimeout(() => {
        setIsLoading(false); // Reset loading state
      }, 500); // 500ms delay
    }
  };

  return (
    <Center flex={1} textAlign={'center'} py={10}>
      <VStack space={3} alignItems={'center'}>
        {isLoading ? (
          <ActivityIndicator
            animating={true}
            color={theme.colors.surface[400]}
            hidesWhenStopped={true}
          />
        ) : (
          <VStack space={5} alignItems={'center'}>
            <Text
              color={theme.colors.surface[400]}
              textTransform={'uppercase'}
              px={20}
              fontWeight={'bold'}
            >
              {error}
            </Text>
            <IconButton
              onPress={handleRefetch}
              borderRadius={'full'}
              borderColor={theme.colors.surface[400]}
              borderWidth={1}
              padding={2}
              size={10}
              icon={
                <RefreshIcon color={theme.colors.surface[500]} size={'20px'} />
              }
              _pressed={{ backgroundColor: 'transparent', opacity: 0.7 }}
            />
          </VStack>
        )}
      </VStack>
    </Center>
  );
}

export default ErrorAndRefetch;
